import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../models/Common';

interface EmailResendProps {
  email: string;
  handleBack: () => void;
  handleResend: () => void;
  isLoading: boolean;
  timer: number;
}

export const EmailResend: FC<EmailResendProps> = ({ timer, email, handleBack, handleResend, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="email-resend">
      <p className="stepper-text">
        {t('auth.aLetterHasBeenSentTo')} <strong>{email}</strong>
        {t('auth.followTheLinkAndClick')}
      </p>
      <div className="email-resend-form">
        <div className="email-resend-form__btn-group email-resend-form__btn-group_center">
          <CustomMUIButton
            label={t('common.back')}
            handleClick={handleBack}
            className={ButtonClassNames.SecondaryOutlined}
          />
          <CustomMUIButton
            label={timer > 0 ? `${t('auth.sendAgain')} (${timer})` : t('auth.sendAgain')}
            handleClick={handleResend}
            className={ButtonClassNames.PrimaryFulfilled}
            isDisabled={timer !== 0}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
